import type { ComponentType, ReactElement } from "react";

// Generic list-toolbar contribution registry. Keeps ActionControlPanel/
// ActionManager free of any specific module: a foundation/domain module drops a
// `frontend/list-toolbar/*.tsx` that default-exports a slot component, and it is
// eager-discovered at boot and rendered in the list toolbar with the active
// list's modelKey. Mirrors the client-action discovery pattern. Each slot is
// expected to render nothing when it doesn't apply to the given model.

export type ListToolbarSlot = ComponentType<{ modelKey?: string }>;

const slots: ListToolbarSlot[] = [];

export function registerListToolbarSlot(component: ListToolbarSlot): void {
    if (!slots.includes(component)) slots.push(component);
}

// Eager glob — `src/ede/foundation/<module>/frontend/list-toolbar/*.{ts,tsx}`.
const FOUNDATION_SLOTS = import.meta.glob<{ default: ListToolbarSlot }>(
    "../../../ede/foundation/*/frontend/list-toolbar/*.{ts,tsx}",
    { eager: true },
);
const DOMAIN_SLOTS = import.meta.glob<{ default: ListToolbarSlot }>(
    "../../../domains/*/*/frontend/list-toolbar/*.{ts,tsx}",
    { eager: true },
);
for (const mod of [...Object.values(FOUNDATION_SLOTS), ...Object.values(DOMAIN_SLOTS)]) {
    if (mod && typeof mod.default === "function") registerListToolbarSlot(mod.default);
}

export function ListToolbarSlots({ modelKey }: { modelKey?: string }): ReactElement {
    return (
        <>
            {slots.map((Slot, i) => (
                <Slot key={i} modelKey={modelKey} />
            ))}
        </>
    );
}
